import { createSlice } from "@reduxjs/toolkit";
import {
  loginUser,
  logoutUser,
  signUp,
  getUserData,
} from "src/thunks/authThunk";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    user: null,
    userData: null,
    status: "idle",
    error: null,
  },
  reducers: {
    setUser: (state, action) => {
      const { user, idToken } = action.payload;
      state.user = { uid: user.uid, email: user.email, idToken };
    },
    clearUser: (state) => {
      state.user = null;
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.token = action.payload.idToken;
        const { user, idToken } = action.payload;
        state.user = { uid: user.uid, email: user.email, idToken };
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.status = "idle";
        state.token = null;
        state.user = null;
        state.userData = null;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(signUp.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.token = action.payload.idToken;
        const { user, idToken, userData } = action.payload;
        state.userData = userData;
        state.user = { uid: user.uid, email: user.email, idToken };
      })
      .addCase(signUp.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getUserData.fulfilled, (state, action) => {
        state.userData = action.payload;
      })
      ;
  },
});

export const { setUser, clearUser } = authSlice.actions;

export default authSlice.reducer;
